const scrollTop = () => {
  window.scroll({
    top: 0,
  });
};

export { scrollTop };
